export default {
  heading: 'Browse games',
  filters: {
    title: 'Filters',
    clearAll: 'Clear all',
    closeAriaLabel: 'Close filters',
    openButton: 'Filters',
    inStockOnly: 'In stock only',
    preorderOnly: 'Pre-orders only',
    category: 'Category',
    comingSoon: 'Coming soon',
    priceRange: 'Price range',
    minEur: 'Min €',
    maxEur: 'Max €',
    showResults: 'Show {count} result | Show {count} results',
    showMore: '+ Show {count} more',
    showLess: '− Show less',
    minPriceAriaLabel: 'Minimum price',
    maxPriceAriaLabel: 'Maximum price',
  },
  chips: {
    search: 'Search: {term}',
    includingSoldOut: 'Including sold out',
    priceFrom: 'From €{min}',
    priceUpTo: 'Up to €{max}',
    priceRange: '€{min} – €{max}',
    remove: 'Remove filter: {filter}',
  },
  sort: {
    label: 'Sort:',
    newest: 'Newest',
    priceAsc: 'Price ↑',
    priceDesc: 'Price ↓',
    nameAsc: 'Name A–Z',
  },
  platformNav: {
    ariaLabel: 'Filter by platform',
    all: 'All platforms',
    gameGoods: 'Game goods',
    other: 'Other',
    showAll: 'Show all',
  },
  toolbar: {
    // Plural word only: the number is rendered separately as a big count.
    results: 'result | results',
    gridViewAriaLabel: 'Grid view',
    listViewAriaLabel: 'List view',
  },
  empty: 'No products match your filters',
  emptyHint: 'Try removing a filter or widening the price range.',
  errorBody: 'We could not load the catalog. Check your connection and try again.',
  pagination: {
    label: 'Pagination',
    previousAriaLabel: 'Previous page',
    nextAriaLabel: 'Next page',
  },
  quickView: {
    label: 'Quick view',
    open: 'Quick view: {name}',
    viewFullPage: 'View full page',
  },
};
